import { Separator } from "@chakra-ui/react-v3";
import { ResourceAnalysis } from "../components/resource-analysis";
import { DocumentsSection } from "../components/side-panel-sections/documents-section";
import { Occurrences } from "../components/occurrences";
import { SidePanelLayout } from "../components/side-panel-sections/side-panel-layout";
import { ConditionRowData } from "../tables/condition";

export type ConditionSidePanelContentProps = {
  data: ConditionRowData;
};

export function ConditionSidePanelContent({ data }: ConditionSidePanelContentProps) {
  const dateRange =
    data.firstSeen !== "-" && data.lastSeen !== "-" && data.firstSeen !== data.lastSeen
      ? `${data.firstSeen} to ${data.lastSeen}`
      : data.lastSeen !== "-"
      ? data.lastSeen
      : data.firstSeen;

  const resources =
    data.conditions && data.conditions.length > 0 ? data.conditions : [data.originalData];

  return (
    <SidePanelLayout title="Condition" subtitle={data.condition} metadata={dateRange}>
      <ResourceAnalysis />

      {data.conditions && (
        <>
          <Separator borderColor="border" />
          <Occurrences conditions={data.conditions} patientDob={data.patientDob} />
        </>
      )}

      <Separator borderColor="border" />

      <DocumentsSection resources={resources} resourceType="Condition" />
    </SidePanelLayout>
  );
}
